/*
    Наименование сервиса
*/
export enum ServiceName {
  //MonitorErrors = 'monitor_errors', // Ошибки монитора
  Coolant = 'coolant', // Контроль СОЖ
  FacilityStructure = 'facility_structure', // Структура
  Workload = 'workload', // Загруженность оборудования
}
